import styled from "styled-components";

const Indent = styled.div`
  padding-left: 10px;
`;

export default Indent;
